import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'firebase/auth';
import DataAnalyzer from "./Charts/DataAnalyizer";
import {auth} from './firebase';
import {Box, Button} from "@mui/material";


export default function Home() {
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [isAdmin, setAdmin] = useState(false)
    const [userRole, setUserRole] = useState(null);

    const handleLogout = () => {
        sessionStorage.removeItem('Auth Token');
        navigate('/login');
    };

    useEffect(() => {
        let authToken = sessionStorage.getItem('Auth Token');
        if (!authToken) {
            navigate('/login');
        }

        const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
                const customAttributes = firebaseUser.reloadUserInfo.customAttributes;
                if (customAttributes) {
                    const parsedAttributes = JSON.parse(customAttributes);
                    console.log("User role from customAttributes:", parsedAttributes.role);
                    if (parsedAttributes.role === "ADMIN") {
                        setAdmin(true);
                    }
                    setUserRole(parsedAttributes.role); // Save the role regardless
                }
                console.log("firebaseUser", firebaseUser);
                setUser(firebaseUser);
            } else {
                setUser(null);
                navigate('/login');
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    return (
        <Box sx={{backgroundColor: '#e8e8e8'}}>
            <Button onClick={handleLogout}>Log out</Button>
            {user && <DataAnalyzer userRole={userRole}
                                   isAdmin={isAdmin} user={user.uid}/>}
        </Box>
    );
}
